import { Avatar, Grid, Stack, Typography } from '@mui/material';
import { IPrescriptionsMedication } from 'API';
import { ListDivider } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { GreenVi, RedAlert } from 'Images';

interface IOrderItemProps {
  item: IPrescriptionsMedication;
  isSuppliedOrPartial: boolean;
}

export const MedicineItem = ({
  item,
  isSuppliedOrPartial,
}: IOrderItemProps) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  return isDesktop ? (
    <>
      <Grid container alignContent={'center'} sx={{ minHeight: '72px' }}>
        <Grid
          container
          item
          xs={6}
          md={isSuppliedOrPartial ? 3 : 4}
          alignContent={'center'}
        >
          <Typography variant='body3'>{item.medicatioN_NAME}</Typography>
        </Grid>
        <Grid container item xs={6} md={4}>
          <Grid container item>
            <Typography variant='body3'>
              {dictionary.dosageDetails(
                item.dosage,
                item.doseperday,
                item.doseperday
              )}
            </Typography>
          </Grid>
        </Grid>

        <Grid container item xs={6} md={isSuppliedOrPartial ? 3 : 4} p={0}>
          {item.medremark && (
            <Typography
              width='100%'
              sx={{ display: 'flex', mr: '10px' }}
              variant='body3'
            >
              {item.medremark}
            </Typography>
          )}
        </Grid>

        {item.supplyind !== undefined && isSuppliedOrPartial && (
          <Grid container item xs={6} md={2}>
            <Avatar
              src={item.supplyind ? GreenVi : RedAlert}
              alt=''
              sx={{
                width: '16px',
                height: '16px',
                alignSelf: 'center',
                mr: '6px',
                display: 'inline-flex',
              }}
            />
            <Typography
              sx={{ display: 'flex', alignItems: 'center' }}
              variant='body3'
            >
              {item.supplyind ? dictionary.supplied : dictionary.notSupplied}
            </Typography>
          </Grid>
        )}
      </Grid>
      <Grid>
        <ListDivider />
      </Grid>
    </>
  ) : (
    <Grid
      container
      justifyContent={'space-between'}
      sx={{
        width: '100%',
        padding: '0',
        pb: 2,
        borderBottom: '1px solid',
        borderColor: 'primary.shade_200',
        mt: 2,
      }}
    >
      <Stack mb={2}>
        <Typography variant='body3' mb={'4px'}>
          {dictionary.nameOfTheMedication}
        </Typography>
        <Typography variant='body2'>{item.medicatioN_NAME}</Typography>
      </Stack>

      <Stack mb={2}>
        <Typography variant='body3' mb={'4px'}>
          {dictionary.dosageTitle}
        </Typography>
        <Typography variant='body2'>
          {dictionary.dosageDetails(
            item.dosage,
            item.doseperday,
            item.doseperday
          )}
        </Typography>
      </Stack>

      <Stack mb={2}>
        <Typography variant='body3' mb={'4px'}>
          {dictionary.notes}
        </Typography>
        <Typography variant='body2'>
          {item.medremark ? item.medremark : dictionary.emptyNotes}
        </Typography>
      </Stack>

      {item.supplyind !== undefined && isSuppliedOrPartial && (
        <Grid
          container
          item
          sx={{
            padding: '0 0 8px',
          }}
        >
          <Avatar
            src={item.supplyind ? GreenVi : RedAlert}
            alt=''
            sx={{
              width: '16px',
              height: '16px',
              alignSelf: 'center',
              mr: '6px',
              display: 'inline-flex',
            }}
          />
          <Typography variant='body6'>
            {item.supplyind ? dictionary.supplied : dictionary.notSupplied}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};
